import { put, call } from 'redux-saga/effects';
import { receiveField } from '../actions/fieldActions';
import { requestField } from '../requesters/fieldRequester';
import { LegacyField } from '../types/LegacyField';

export interface FieldData {
  fieldUUID: string;
  fieldLegacyId: number;
  fieldOwnerId: number;
}

export function* getField(fieldId: string): Generator<unknown, FieldData, LegacyField>  {
  const response = yield call(requestField, fieldId);
  yield put(receiveField(response));

  return {
    fieldUUID: response.uuid,
    fieldLegacyId: response.id,
    fieldOwnerId: response.userId,
  };
}
